import { SC } from 'helper/ServerCall';

export const adminUserService = {
    login,
    logout,
    dashboard,
    dashboardMenu,
}
function login(user_name, password) {
    return SC.postCallLoginAdmin('auth/login', { user_name: user_name, password });
}

function logout() {
    return SC.getCall('logout');
}

function dashboard() {
    return SC.getCall('dashboard');
}

function dashboardMenu() {
    return SC.getCall('getMenu');
}


// WEBPACK FOOTER //
// ./src/services/adminUser.js